import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { Disclaimer, DisclaimerData } from './disclaimer';
import { GuestFormData } from './guest-disclaimer-form/guest-disclaimer-form';
import { GuestInfo, GuestService } from '@core/auth';
import { MibBreakpointService } from '@medinbox/angular';
import { Overlay } from '@angular/cdk/overlay';
import { SharedVideoId } from '@shared/models/user/shared-video-id';

@Injectable({
  providedIn: 'root',
})
export class DisclaimerService {
  private readonly dialog = inject(Dialog);
  private readonly overlay = inject(Overlay);
  private readonly guestService = inject(GuestService);
  private readonly breakpointService = inject(MibBreakpointService);

  openDisclaimer(
    showGuestForm = false,
    videoIds?: SharedVideoId[],
    guestInfo?: GuestInfo,
  ): DialogRef<GuestFormData | boolean> {
    let formData: GuestFormData | undefined;
    if (showGuestForm) {
      formData = guestInfo ?? this.guestService.getGuestInfo();
    }
    // On Firefox Android, the native autofill banner is an overlay displayed on bottom
    // of the screen and not included in dvh (as it's an overlay)
    // So we position the dialog on top of the screen
    // and it is smaller than usual dialogs to make sure footer is accessible by user
    const positionStrategy =
      this.breakpointService.sizeClass() !== 'expanded'
        ? this.overlay.position().global().centerHorizontally().top('0.5rem')
        : this.overlay.position().global().centerHorizontally().centerVertically();
    return this.dialog.open<GuestFormData | boolean, DisclaimerData>(Disclaimer, {
      ariaLabel: 'Disclaimer',
      disableClose: true,
      data: { showGuestForm, videoIds, formData },
      positionStrategy,
    });
  }
}
